import { render, staticRenderFns } from "./PelvicPain.vue?vue&type=template&id=ca290b4c&scoped=true"
import script from "./PelvicPain.vue?vue&type=script&lang=js"
export * from "./PelvicPain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca290b4c",
  null
  
)

export default component.exports